module.exports = __webpack_public_path__ + "static/media/galdinsLose_2500_5000.e888a734.png";